// import React, { useState } from 'react';
// import { useApp } from '../../../context/AppContext';
// import PageHeader from '../../../components/PageHeader/PageHeader';
// import Input from '../../../components/Form/Input';
// import Button from '../../../components/Form/Button';
// import { useToast } from '../../../context/ToastContext';
// import './Profile.css';

// const AgentProfile = () => {
//     const { currentUser, updateUser } = useApp();
//     const { showToast } = useToast();

//     const [formData, setFormData] = useState({
//         name: currentUser?.name || '',
//         phone: currentUser?.phone || '',
//         city: currentUser?.city || '',
//     });

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData(prev => ({ ...prev, [name]: value }));
//     };

//     const handleSubmit = (e) => {
//         e.preventDefault();
//         // In production, this would make an API call
//         if (currentUser) {
//             updateUser(currentUser.id, formData);
//             showToast('Profile updated successfully!', 'success');
//         }
//     };

//     return (
//         <div className="agent-profile">
//             <PageHeader title="Profile" />

//             <div className="profile-container">
//                 <form onSubmit={handleSubmit} className="profile-form">
//                     <div className="profile-section">
//                         <h2 className="profile-section-title">Personal Information</h2>
//                         <div className="profile-grid">
//                             <Input
//                                 label="Name"
//                                 name="name"
//                                 value={formData.name}
//                                 onChange={handleChange}
//                                 required
//                             />
//                             <Input
//                                 label="Phone"
//                                 name="phone"
//                                 value={formData.phone}
//                                 onChange={handleChange}
//                                 required
//                             />
//                             <Input
//                                 label="City"
//                                 name="city"
//                                 value={formData.city}
//                                 onChange={handleChange}
//                                 required
//                             />
//                         </div>
//                     </div>

//                     <div className="profile-actions">
//                         <Button type="submit" variant="primary">
//                             Save Changes
//                         </Button>
//                     </div>
//                 </form>
//             </div>
//         </div>
//     );
// };

// export default AgentProfile;



import React, { useState, useEffect } from 'react';
import { useApp } from '../../../context/AppContext';
import PageHeader from '../../../components/PageHeader/PageHeader';
import Input from '../../../components/Form/Input';
import Button from '../../../components/Form/Button';
import { useToast } from '../../../context/ToastContext';
import './Profile.css';

const AgentProfile = () => {
    const { currentUser, updateProfile, fetchCurrentProfile } = useApp();
    const { showToast } = useToast();

    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        city: '',
    });

    // Load existing profile into form
    useEffect(() => {
        if (currentUser) {
            setFormData({
                name: currentUser.name ?? '',
                phone: currentUser.phone ?? '',
                city: currentUser.city ?? currentUser.address?.city ?? '',
            });
        }
    }, [currentUser]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            await updateProfile({
                name: formData.name,
                phone: formData.phone,
                city: formData.city,
            });

            showToast('Profile updated successfully!', 'success');

            // refresh profile
            await fetchCurrentProfile();

        } catch (err) {
            console.error(err);
            showToast('Failed to update profile', 'error');
        }
    };

    return (
        <div className="agent-profile">
            <PageHeader title="Profile" />

            <div className="profile-container">
                <form onSubmit={handleSubmit} className="profile-form">
                    <div className="profile-section">
                        <h2 className="profile-section-title">Personal Information</h2>
                        <div className="profile-grid">
                            <Input label="Name" name="name" value={formData.name} onChange={handleChange} required />
                            <Input label="Phone" name="phone" value={formData.phone} onChange={handleChange} required />
                            {/* <Input label="City" name="city" value={formData.city} onChange={handleChange} required /> */}
                        </div>
                    </div>

                    <div className="profile-actions">
                        <Button type="submit" variant="primary">Save Changes</Button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AgentProfile;
